import { createSelector } from 'reselect';
import { entitiesSelector } from '../common/state/selectors/issue-selector.tsx';

export const persistedChildrenIssuesSelector = createSelector(
	entitiesSelector,
	(entities) => entities.childrenIssues || [],
);
